import { render, staticRenderFns } from "./DataTableExpandableComponent.vue?vue&type=template&id=439f98d2&scoped=true&"
import script from "./DataTableExpandableComponent.vue?vue&type=script&lang=js&"
export * from "./DataTableExpandableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataTableExpandableComponent.vue?vue&type=style&index=0&id=439f98d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439f98d2",
  null
  
)

export default component.exports